import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  useTheme,
} from "@mui/material";

const EditUserModal = ({ open, onClose, user, onConfirm }) => {
  const theme = useTheme();

  // Estados dos campos do formulário
  const [paidAt, setPaidAt] = useState(user.paid_at || "");
  const [subscriptionExpiresAt, setSubscriptionExpiresAt] = useState(
    user.subscription_expires_at || ""
  );
  const [discount, setDiscount] = useState(user.discount_type || "none");
  const [amount, setAmount] = useState(user.amount || 299.0);
  const [method, setMethod] = useState(user.payment_method || "cartao");
  const [paymentCreatedAt, setPaymentCreatedAt] = useState(user.created_at || "");
  const [paymentUpdatedAt, setPaymentUpdatedAt] = useState(user.updated_at || "");

  // Atualiza a data de expiração automaticamente
  const handlePaidAtChange = (e) => {
    const newPaidAt = e.target.value;
    setPaidAt(newPaidAt);

    if (newPaidAt) {
      const date = new Date(newPaidAt);
      date.setFullYear(date.getFullYear() + 1);
      setSubscriptionExpiresAt(date.toISOString().slice(0, 16));
    }
  };

  // Confirmação da edição - **CHAMANDO API**
  const handleConfirm = async () => {
    const token = localStorage.getItem("token");
    const updatedData = {
      is_paid: 1,
      paid_at: paidAt,
      subscription_expires_at: subscriptionExpiresAt,
      status: "ativo",
      discount_type: discount,
      amount,
      method,
      created_at: paymentCreatedAt,
      updated_at: paymentUpdatedAt,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/${user.id}/update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(updatedData),
        }
      );

      const data = await response.json();
      if (response.ok) {
        console.log("Usuário atualizado com sucesso:", data);
        if (typeof onConfirm === "function") {
          onConfirm(updatedData);
        }
        onClose();
      } else {
        console.error("Erro ao atualizar usuário:", data.message);
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontWeight: "bold",
        }}
      >
        Editar Usuário e Pagamento
      </DialogTitle>
      <DialogContent sx={{ padding: theme.spacing(3), color: theme.palette.text.primary }}>
        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.primary }}>
            Data do Pagamento:
          </Typography>
          <TextField
            type="datetime-local"
            value={paidAt}
            onChange={handlePaidAtChange}
            fullWidth
            InputProps={{ sx: { color: theme.palette.text.primary } }}
          />
          <Button
            onClick={() => {
              const now = new Date().toISOString().slice(0, 16);
              setPaidAt(now);
              handlePaidAtChange({ target: { value: now } });
            }}
            sx={{ mt: theme.spacing(1), color: theme.palette.primary.main }}
          >
            Usar Data Atual
          </Button>
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.primary }}>
            Expiração da Assinatura:
          </Typography>
          <TextField
            type="datetime-local"
            value={subscriptionExpiresAt}
            onChange={(e) => setSubscriptionExpiresAt(e.target.value)}
            fullWidth
            InputProps={{ sx: { color: theme.palette.text.primary } }}
          />
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <InputLabel sx={{ color: theme.palette.text.secondary }}>
            Desconto
          </InputLabel>
          <Select
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            sx={{ color: theme.palette.text.primary }}
          >
            <MenuItem value="none">Nenhum</MenuItem>
            <MenuItem value="Desconto 199">Desconto 199</MenuItem>
            <MenuItem value="Desconto 179">Desconto 179</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <InputLabel sx={{ color: theme.palette.text.secondary }}>
            Valor do Pagamento
          </InputLabel>
          <Select
            value={amount}
            onChange={(e) => setAmount(parseFloat(e.target.value))}
            sx={{ color: theme.palette.text.primary }}
          >
            <MenuItem value={299.0}>299.00</MenuItem>
            <MenuItem value={249.0}>249.00</MenuItem>
            <MenuItem value={199.0}>199.00</MenuItem>
            <MenuItem value={170.0}>170.00</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <InputLabel sx={{ color: theme.palette.text.secondary }}>
            Método de Pagamento
          </InputLabel>
          <Select
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            sx={{ color: theme.palette.text.primary }}
          >
            <MenuItem value="cartao">Cartão</MenuItem>
            <MenuItem value="pix">Pix</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.primary }}>
            Data de Criação do Pagamento:
          </Typography>
          <TextField
            type="datetime-local"
            value={paymentCreatedAt}
            onChange={(e) => setPaymentCreatedAt(e.target.value)}
            fullWidth
            InputProps={{ sx: { color: theme.palette.text.primary } }}
          />
        </FormControl>

        <FormControl fullWidth sx={{ marginBottom: theme.spacing(2) }}>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.primary }}>
            Data de Atualização do Pagamento:
          </Typography>
          <TextField
            type="datetime-local"
            value={paymentUpdatedAt}
            onChange={(e) => setPaymentUpdatedAt(e.target.value)}
            fullWidth
            InputProps={{ sx: { color: theme.palette.text.primary } }}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ padding: theme.spacing(2), justifyContent: "space-between" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
            "&:hover": {
              backgroundColor: theme.palette.error.main,
              color: theme.palette.text.primary,
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleConfirm}
          sx={{
            backgroundColor: theme.palette.primary.main,
            "&:hover": { backgroundColor: theme.palette.primary.dark },
          }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserModal;
